// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2z5ux","title":"InfoRow_title__20Moc"};